
// prototype utilities
Object.defineProperty(String.prototype, 'matchFromStart', {
  enumerable: false,
  value: function (s2) {
    let n = this.length, score = 0, _s2 = (typeof s2 !== 'string' ? s2.toString() : s2);
    for (let i = 0; i < n; i++) {
      if (this[i] === _s2[i]) score++;
      else break;
    }
    return score;
  }
})

Object.defineProperty(String.prototype, "capitalize", {
  // no argumemt
  // returns the same string but with the first letter capitalized
  // usage: "this is an apple.".capitalize()
  // returns "This is an apple."
  enumerable: false,
  value: function () {
    if (this.length >= 1) return this[0].toUpperCase() + this.slice(1);
    else return "";
  }
});

Object.defineProperty(Array.prototype, 'argMax', {
  enumerable: false,
  value: function (cb, recur) {
    let _cb = (!cb ? (a, b) => { return b - a } : cb);
    let max = Array.from(this).sort(_cb)[0];
    if (recur) {
      return this.map((val, ind) => (val == max ? ind : undefined)).filter(val => val !== undefined);
    } else {
      let i = this.indexOf(max);
      return i;
    }
  }
})

Object.defineProperty(Array.prototype, "argFilter", {
  enumerable: false,
  value: function (comparer) {
    return this.map((d, i) => (comparer(d) ? i : undefined)).filter((d) => d !== undefined);
  }
});

Object.defineProperty(Array.prototype, "filterByIndex", {
  enumerable: false,
  value: function (args) {
    return this.filter((d, i) => args.includes(i));
  }
});

Object.defineProperty(String.prototype, "hashString", {
  enumerable: false,
  value: function () {
    let hash = 0;
    this.split("").forEach(s => {
      hash = hash = ((hash << 5) - hash) + s.charCodeAt(0);
      hash = hash & hash;
    })
    let hash_string = (hash % 99991).toString();
    if (hash_string.startsWith('-')) hash_string = hash_string.replace('-', 'n');
    else hash_string = 'p' + hash_string;
    return hash_string;
  }
});


Object.defineProperty(Array.prototype, "f$sum", {
  // from: https://github.com/see-mike-out/some-useful-js-prototype
  // returns the sum of elements
  // [1, 2, 3, 4, 5].sum() // 15
  enumerable: false,
  value: function () {
    return this.reduce((a, c) => a + c, 0);
  }
});

Object.defineProperty(Array.prototype, "f$max", {
  // from: https://github.com/see-mike-out/some-useful-js-prototype
  // returns the max of elements
  // [1, 2, 3, 4, 5].max() // 5
  enumerable: false,
  value: function () {
    return Math.max(...this);
  }
});

Object.defineProperty(Array.prototype, "argDiff", {
  // from: https://github.com/see-mike-out/some-useful-js-prototype
  // returns the differences of consecutive elements
  // [1, 2, 5, 3, 0].argDiff()
  // return [-1, -3, 2, 3]
  enumerable: false,
  value: function () {
    return Array.zeros(this.length - 1).map((d, i) => this[i] - this[i + 1]);
  }
});

Object.defineProperty(Array.prototype, "argAbsDiff", {
  // from: https://github.com/see-mike-out/some-useful-js-prototype
  // returns the absolute differences of consecutive elements
  // [1, 2, 5, 3, 0].argDiff()
  // return [1, 3, 2, 3]
  enumerable: false,
  value: function () {
    return Array.zeros(this.length - 1).map((d, i) => Math.abs(this[i] - this[i + 1]));
  }
});

Array.zeros = function (n) {
  // from: https://github.com/see-mike-out/some-useful-js-prototype
  // returns a length-n array filled with zeros.
  // Array.zeros(6) // [0, 0, 0, 0, 0, 0]
  let a = [];
  for (let i = 0; i < n; i++) a[i] = 0;
  return a;
}

Object.defineProperty(Array.prototype, "mean", {
  // returns the mean of elements
  // [1, 2, 3, 4, 5].mean() // 3
  // @ignoreNAN (optional; default: false): if set true, then it ignores NAN; if false, NAN considered as 0.
  // @strict (default: false): if set true, returns null when there is any NAN.
  // When the length of the adjusted array (NAN removed if ignoreNAN is true) is 0, then it returns null.
  enumerable: false,
  value: function (ignoreNAN = false, strict = false) {
    if (this.length == 0) return null;
    let b;
    if (!ignoreNAN && strict && this.some(d => isNaN(d))) return null;
    if (ignoreNAN) b = this.filter(d => !isNaN(d)).map(d => parseFloat(d));
    else b = this.filter(d => d !== null && d !== undefined ? parseFloat(d) : 0);
    if (b.length == 0) return null;
    return b.reduce((a, c) => a + c, 0) / b.length;
  }
});

Object.defineProperty(Array.prototype, "stdev", {
  // returns the standard deviation of elements
  // [1, 2, 3, 4, 5].stdev() // 3
  // @ignoreNAN (optional; default: false): if set true, then it ignores NAN; if false, NAN considered as 0.
  // @strict (default: false): if set true, returns null when there is any NAN.
  // @sample (default: true): if set false, calculates population standard deviation (degree of freedom == the length of the array).
  // When the length of the adjusted array (NAN removed if ignoreNAN is true) is 0, then it returns null.
  enumerable: false,
  value: function (ignoreNAN = false, strict = false, sample = true) {
    if (this.length == 0) return null;
    let b;
    if (!ignoreNAN && strict && this.some(d => isNaN(d))) return null;
    if (ignoreNAN) b = this.filter(d => !isNaN(d)).map(d => parseFloat(d));
    else b = this.filter(d => d !== null && d !== undefined ? parseFloat(d) : 0);
    if (b.length == 0) return null;
    else if (b.length == 1 && sample) return null;
    else if (b.length == 1 && !sample) return 0;
    let m = b.reduce((a, c) => a + c, 0) / b.length;
    if (m == null) return null;
    let v = b.map(d => (d - m) ** 2).reduce((a, c) => a + c, 0) / (sample ? b.length - 1 : b.length);
    return Math.sqrt(v);
  }
});